import {
  setUser,
  setInitialized,
  setLoading,
  setTokens,
  clearAuth,
} from "reduxFiles/slices/authSlice";
import { authApi } from "reduxFiles/api/authApi";
import { companyApi } from "reduxFiles/api/companyApi";
import { store } from "reduxFiles/store";
import { assessmentApi } from "reduxFiles/api/assessmentApi";
import { userApi } from "reduxFiles/api/userApi";

export const authLoader = async () => {
  try {
    const state = store.getState();
    const { refreshToken } = state.auth;

    store.dispatch(setLoading(true));

    if (!refreshToken) {
      store.dispatch(setInitialized(true));
      store.dispatch(setLoading(false));
      return;
    }

    try {
      const user = await store
        .dispatch(
          userApi.endpoints.getUserProfile.initiate(undefined, {
            forceRefetch: true,
          })
        )
        .unwrap();

      store.dispatch(setUser(user));

      // province
      await store.dispatch(
        companyApi.endpoints.getProvinces.initiate(undefined, {
          forceRefetch: false,
        })
      );
      // tag
      await store.dispatch(
        companyApi.endpoints.getTags.initiate(undefined, {
          forceRefetch: false,
        })
      );
      // group
      await store.dispatch(
        assessmentApi.endpoints.getGroups.initiate(undefined, {
          forceRefetch: false,
        })
      );
      // criteria
      await store.dispatch(
        assessmentApi.endpoints.getCriterias.initiate(undefined, {
          forceRefetch: false,
        })
      );
      // industries
      await store.dispatch(
        companyApi.endpoints.getIndustries.initiate(undefined, {
          forceRefetch: false,
        })
      );
      // settings
      await store.dispatch(
        authApi.endpoints.getSettings.initiate(undefined, {
          forceRefetch: false,
        })
      );
    } catch (error: any) {
      console.warn("Failed to fetch user profile:", error);

      if (refreshToken) {
        try {
          const refreshResult = await store
            .dispatch(
              authApi.endpoints.refreshToken.initiate(
                { refreshToken },
                { track: false }
              )
            )
            .unwrap();

          store.dispatch(setTokens(refreshResult));

          const retryUser = await store
            .dispatch(
              userApi.endpoints.getUserProfile.initiate(undefined, {
                forceRefetch: true,
              })
            )
            .unwrap();

          store.dispatch(setUser(retryUser));
        } catch (refreshError) {
          store.dispatch(clearAuth());
          console.warn("Failed to refresh token:", refreshError);
        }
      }
    }
  } catch (error) {
    console.error("Auth loader error:", error);
    store.dispatch(clearAuth());
  } finally {
    store.dispatch(setInitialized(true));
    store.dispatch(setLoading(false));
  }
};
